"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordClicked = exports.recordDismissed = exports.recordShown = exports.pickPost = exports.withRef = exports.pickVariant = exports.shouldShow = void 0;
const config_1 = require("./config");
const DAY_MS = 24 * 60 * 60 * 1000;
// localStorage may be disabled (private mode, quota, SSR) — never throw.
const safeGet = (key) => {
    try {
        return localStorage.getItem(key);
    }
    catch (_a) {
        return null;
    }
};
const safeSet = (key, value) => {
    try {
        localStorage.setItem(key, value);
    }
    catch (_a) {
        /* storage disabled / quota — ignore */
    }
};
/** True if `key` holds a timestamp newer than `days` ago (i.e. still suppressing). */
const isWithin = (key, days) => {
    const raw = safeGet(key);
    if (!raw)
        return false;
    const ts = Number(raw);
    if (!Number.isFinite(ts))
        return false;
    return Date.now() - ts < days * DAY_MS;
};
/**
 * Decide whether the banner should appear on this page load.
 * Suppressed by an active cooldown / dismissal / click-through; otherwise
 * gated by a random probability so it stays occasional.
 */
const shouldShow = () => {
    if (config_1.BLOG_POSTS.length === 0)
        return false;
    if (isWithin(config_1.STORAGE_KEYS.clickedAt, config_1.CLICKED_DAYS))
        return false;
    if (isWithin(config_1.STORAGE_KEYS.dismissedAt, config_1.DISMISS_DAYS))
        return false;
    if (isWithin(config_1.STORAGE_KEYS.lastShown, config_1.COOLDOWN_DAYS))
        return false;
    return Math.random() < config_1.SHOW_PROBABILITY;
};
exports.shouldShow = shouldShow;
/**
 * Roll the A/B variant fresh on every show (not persisted), so the split stays
 * ~50/50 across all impressions and a returning user may see either version.
 */
const pickVariant = () => Math.random() < config_1.AB_SPLIT_MINIMAL ? "minimal" : "full";
exports.pickVariant = pickVariant;
/**
 * Append attribution params to a blog URL so the click can be traced through to
 * a HabitatMap purchase. Preserves any existing query string; falls back to the
 * raw URL if it can't be parsed.
 */
const withRef = (url, variant, postSlug) => {
    try {
        const u = new URL(url);
        u.searchParams.set("utm_source", config_1.LINK_REF.utmSource);
        u.searchParams.set("utm_medium", config_1.LINK_REF.utmMedium);
        u.searchParams.set("utm_campaign", config_1.LINK_REF.utmCampaign);
        u.searchParams.set("utm_content", variant);
        u.searchParams.set("ac_post", postSlug);
        return u.toString();
    }
    catch (_a) {
        return url;
    }
};
exports.withRef = withRef;
/** Pick a random post, avoiding the one shown last time when possible. */
const pickPost = () => {
    const lastPostSlug = safeGet(config_1.STORAGE_KEYS.lastPostSlug);
    const candidates = config_1.BLOG_POSTS.length > 1
        ? config_1.BLOG_POSTS.filter((p) => p.postSlug !== lastPostSlug)
        : config_1.BLOG_POSTS;
    const pool = candidates.length > 0 ? candidates : config_1.BLOG_POSTS;
    return pool[Math.floor(Math.random() * pool.length)];
};
exports.pickPost = pickPost;
/** Record that the banner was actually shown (starts the cooldown). */
const recordShown = (post) => {
    safeSet(config_1.STORAGE_KEYS.lastShown, String(Date.now()));
    safeSet(config_1.STORAGE_KEYS.lastPostSlug, post.postSlug);
};
exports.recordShown = recordShown;
const recordDismissed = () => {
    safeSet(config_1.STORAGE_KEYS.dismissedAt, String(Date.now()));
};
exports.recordDismissed = recordDismissed;
const recordClicked = () => {
    safeSet(config_1.STORAGE_KEYS.clickedAt, String(Date.now()));
};
exports.recordClicked = recordClicked;
